import React from 'react';

export const exampleInstanceName = 'modal/example';

export default {
  [exampleInstanceName]: React.lazy(() => import('./Example')),
};



// WEBPACK FOOTER //
// ./src/modals/config.js